import React, { useState } from 'react';
import { TextField } from '@mui/material';

const EditableNumberCell = ({ id, field, value, label, saveEditedField, darkMode, equipment, categoryUuid, workId }) => {
    // Определяем цвета в зависимости от поля
    const getFieldColors = (field) => {
        switch (field) {
            case 'stage':
                return {
                    color: darkMode ? '#ab47bc' : '#6a1b9a',
                };
            case 'closing':
                return {
                    color: darkMode ? '#ff8f00' : '#e65100',
                };
            case 'cost':
                return {
                    color: darkMode ? '#e91e63' : '#c2185b',
                };
            case 'fid':
                return {
                    color: darkMode ? '#1976d2' : '#1976d2',
                };
            default:
                return {
                    color: darkMode ? '#9c27b0' : '#9c27b0',
                };
        }
    };

    const fieldColors = getFieldColors(field);
    // Инициализируем localValue с учетом типа поля
    const [localValue, setLocalValue] = useState(() => {
        if (field === 'closing' || field === 'cost') {
            // Для вещественных чисел отображаем с двумя знаками после запятой
            return value !== null && value !== undefined ? parseFloat(value).toFixed(2) : '';
        }
        if (field === 'stage') {
            // Для этапа отображаем с одним знаком после запятой или как целое число
            if (value !== null && value !== undefined) {
                const numValue = parseFloat(value);
                if (!isNaN(numValue)) {
                    // Если число целое, отображаем без десятичной части
                    if (numValue % 1 === 0) {
                        return String(numValue);
                    }
                    // Иначе отображаем с одним знаком после запятой
                    return numValue.toFixed(1);
                }
            }
            return '';
        }
        return value || '';
    });

    const handleNumberChange = (e) => {
        const inputValue = e.target.value;

        // Для полей closing и cost разрешаем вещественные числа с двумя знаками после запятой
        if (field === 'closing' || field === 'cost') {
            // Разрешаем цифры, точку, запятую и пустую строку
            // Также разрешаем формат с двумя знаками после запятой
            if (inputValue === '' || /^[\d.,]+$/.test(inputValue)) {
                // Заменяем запятую на точку для корректной обработки
                const normalizedValue = inputValue.replace(',', '.');
                // Проверяем, что после точки не более двух цифр и нет множественных точек
                if (normalizedValue === '' || /^\d*\.?\d{0,2}$/.test(normalizedValue)) {
                    // Дополнительная проверка на множественные точки
                    const dotCount = (normalizedValue.match(/\./g) || []).length;
                    if (dotCount <= 1) {
                        setLocalValue(inputValue);
                    }
                }
            }
        } else if (field === 'stage') {
            // Для поля stage разрешаем целые числа или числа с одним знаком после запятой
            if (inputValue === '' || /^[\d.,]+$/.test(inputValue)) {
                // Заменяем запятую на точку для корректной обработки
                const normalizedValue = inputValue.replace(',', '.');
                // Проверяем, что после точки не более одной цифры и нет множественных точек
                if (normalizedValue === '' || /^\d*\.?\d{0,1}$/.test(normalizedValue)) {
                    // Дополнительная проверка на множественные точки
                    const dotCount = (normalizedValue.match(/\./g) || []).length;
                    if (dotCount <= 1) {
                        setLocalValue(inputValue);
                    }
                }
            }
        } else {
            // Для остальных полей оставляем только целые числа
            if (inputValue === '' || /^\d+$/.test(inputValue)) {
                setLocalValue(inputValue);
            }
        }
    };

    const handleBlur = () => {
        console.log(value, localValue)
        let numericValue;

        if (field === 'closing' || field === 'cost') {
            // Для вещественных чисел парсим как float
            numericValue = localValue ? parseFloat(localValue.replace(',', '.')) : value;
            // Округляем до двух знаков после запятой
            numericValue = isNaN(numericValue) ? value : Math.round(numericValue * 100) / 100;

            // Если значение некорректное, восстанавливаем исходное
            if (isNaN(numericValue)) {
                setLocalValue(formatDisplayValue(value));
                return;
            }
        } else if (field === 'stage') {
            // Для поля stage парсим как float и округляем до одного знака после запятой
            numericValue = localValue ? parseFloat(localValue.replace(',', '.')) : value;
            // Округляем до одного знака после запятой
            numericValue = isNaN(numericValue) ? value : Math.round(numericValue * 10) / 10;

            // Если значение некорректное, восстанавливаем исходное
            if (isNaN(numericValue)) {
                if (value !== null && value !== undefined) {
                    const numValue = parseFloat(value);
                    if (!isNaN(numValue)) {
                        if (numValue % 1 === 0) {
                            setLocalValue(String(numValue));
                        } else {
                            setLocalValue(numValue.toFixed(1));
                        }
                    } else {
                        setLocalValue('');
                    }
                } else {
                    setLocalValue('');
                }
                return;
            }
        } else {
            // Для остальных полей парсим как целое число
            numericValue = localValue ? parseInt(localValue, 10) : value;

            // Если значение некорректное, восстанавливаем исходное
            if (isNaN(numericValue)) {
                setLocalValue(value || '');
                return;
            }
        }


        saveEditedField({
            rowId: id,
            field: field,
            value: numericValue,
            isValueChanged: (value || '') !== localValue,
            equipment: equipment,
            categoryUuid: categoryUuid,
            workId: workId,
        });


    };

    const handleClear = () => {
        setLocalValue('');
    };

    // Функция для форматирования значения при отображении
    const formatDisplayValue = (val) => {
        if (field === 'closing' || field === 'cost') {
            // Для вещественных чисел форматируем с двумя знаками после запятой
            return val !== null && val !== undefined ? parseFloat(val).toFixed(2) : '';
        }
        if (field === 'stage') {
            // Для этапа форматируем с одним знаком после запятой или как целое число
            if (val !== null && val !== undefined) {
                const numValue = parseFloat(val);
                if (!isNaN(numValue)) {
                    // Если число целое, отображаем без десятичной части
                    if (numValue % 1 === 0) {
                        return String(numValue);
                    }
                    // Иначе отображаем с одним знаком после запятой
                    return numValue.toFixed(1);
                }
            }
            return '';
        }
        return val || '';
    };

    const handleSave = () => {
        handleBlur();
    };

    // Обработка нажатия Enter
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleBlur();
        }
    };

    return (
        <TextField
            data-editing-cell="true"
            fullWidth
            size="small"
            value={localValue}
            onChange={handleNumberChange}
            onBlur={handleBlur}
            onKeyPress={handleKeyPress}
            autoFocus
            sx={{
                '& .MuiOutlinedInput-input': {
                    p: '5px',
                    cursor: 'text',
                    color: darkMode ? '#ffffff' : '#333',
                    fontSize: '0.875rem',
                },
                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: fieldColors.color,
                    borderWidth: '2px',
                },
                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: darkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
                },
                '& .MuiInputLabel-root': {
                    color: darkMode ? '#bbb' : 'rgba(0,0,0,0.6)',
                    fontSize: '0.875rem',
                    '&.Mui-focused': {
                        color: fieldColors.color,
                    }
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: darkMode ? 'rgba(255,255,255,0.23)' : 'rgba(0,0,0,0.23)',
                    borderRadius: '4px',
                },
                bgcolor: darkMode ? '#2b2b2b' : '#fff',
                '& .MuiInputBase-root': {
                    fontWeight: 500,
                    fontSize: '0.8rem',
                    borderRadius: '4px',
                    minWidth: '60px',
                },
                '& .MuiInputBase-input': {
                    borderRadius: '4px',
                },
            }}
        />
    );
};

export default EditableNumberCell;

